import React, { useEffect } from 'react'
import { TextHeader } from '@wallyhealth/web-core'
import intelService from '../../services/intelService'
import styles from './index.module.css'
import CenteredLayout from './CenteredLayout'

const OptOutSuccessPage = () => {
  useEffect(() => {
    intelService.recordView({ viewName: 'OptOutSuccessPage' })
  }, [])

  return (
    <CenteredLayout>
      <TextHeader
        title="You've been unsubscribed."
        subtitle="You'll no longer receive marketing emails from us."
        titleClassName={styles.centerText}
        subtitleClassName={styles.centerText}
      />
    </CenteredLayout>
  )
}

export default OptOutSuccessPage
